// src/app/layout/CoreMobileNavDrawer.tsx
import { useEffect } from 'react';
import { X } from 'lucide-react';
import { CoreNavList } from './CoreNavList';

interface CoreMobileNavDrawerProps {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * Mobile/tablet (< lg) counterpart to CoreSidebar. Renders the same
 * CoreNavList the desktop sidebar uses — no second copy of the nav
 * data. Same pattern as Step 1's MobileNavDrawer.
 */
export function CoreMobileNavDrawer({ isOpen, onClose }: CoreMobileNavDrawerProps) {
  useEffect(() => {
    if (!isOpen) return;

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onClose]);

  return (
    <div
      className={`vania-shell-mobile-nav xl:hidden${isOpen ? ' is-open' : ''}`}
      aria-hidden={!isOpen}
      style={{ overflow: 'clip', contain: 'paint' }}
    >
      <div
        onClick={onClose}
        className={[
          'fixed inset-0 z-40 bg-black/50 transition-opacity duration-300',
          isOpen ? 'opacity-100' : 'pointer-events-none opacity-0',
        ].join(' ')}
      />

      <aside
        role="dialog"
        aria-modal="true"
        aria-label="منوی ناوبری"
        className={[
          'absolute inset-y-0 start-0 z-50 flex w-72 max-w-[80vw] flex-col',
          'vania-command-sidebar vania-shell-sidebar vania-shell-mobile-drawer',
          'transition-transform duration-300 ease-in-out',
          isOpen ? 'translate-x-0' : 'translate-x-full',
        ].join(' ')}
      >
        <div className="vania-command-brand vania-shell-brand vania-shell-mobile-header">
          <div className="vania-shell-mobile-brand">
            <span className="vania-shell-brand-mark">
              V
            </span>
          </div>
          <button
            type="button"
            onClick={onClose}
            aria-label="بستن منو"
            className="vania-shell-icon-button"
          >
            <X size={18} strokeWidth={2.2} />
          </button>
        </div>

        <CoreNavList onItemSelect={onClose} />
      </aside>
    </div>
  );
}
